import { render, staticRenderFns } from "./AddressBookManage.vue?vue&type=template&id=6792cbdc&scoped=true"
import script from "./AddressBookManage.vue?vue&type=script&lang=js"
export * from "./AddressBookManage.vue?vue&type=script&lang=js"
import style0 from "./AddressBookManage.vue?vue&type=style&index=0&id=6792cbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6792cbdc",
  null
  
)

export default component.exports